import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectSelectedTake3D,
  selectTakes3D,
  setSelectedTakeSequence,
} from "../../../app/slices/TrainingSlice";
import { getTriggerChainNodeIds, ON_TAKE_END } from "../../../helpers/TakeTriggerChain";
import { getTake3DSequence } from "../../../models/Take3D";
import { PreviousTakeExit } from "./TakeSetupFlow";

/**
 * The previous take's On Take End, when it has nodes: they play at the same
 * time as the selected take's setup.
 */
export default function usePreviousTakeExit(): PreviousTakeExit | undefined {
  const dispatch = useDispatch();
  const takes = useSelector(selectTakes3D);
  const take = useSelector(selectSelectedTake3D);
  const index = take ? takes.findIndex((candidate) => candidate.id === take.id) : -1;
  const previousTake = index > 0 ? takes[index - 1] : undefined;

  return useMemo(() => {
    if (!previousTake) return undefined;
    const nodeCount = getTriggerChainNodeIds(getTake3DSequence(previousTake), ON_TAKE_END).length;
    if (nodeCount === 0) return undefined;
    return {
      takeName: previousTake.name,
      nodeCount,
      open: () => dispatch(setSelectedTakeSequence(previousTake.id)),
    };
  }, [dispatch, previousTake]);
}
